module.exports = __webpack_public_path__ + "img/android-app.a9141350.png";